import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';
import {WsLogPageData} from '../../../../generated-model/models';

@Injectable({providedIn: 'root'})
export class WsLogService {
  private readonly http = inject(HttpClient);

  search(params: Record<string, string | number>): Observable<PageResponse<WsLogPageData>> {
    return this.http.get<PageResponse<WsLogPageData>>('/api/ws-logs', {params: params as any});
  }
}
